import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UnlinkUserFromEventMutationVariables = Types.Exact<{
  event_id: Types.Scalars['ID'];
  user_id: Types.Scalars['ID'];
}>;


export type UnlinkUserFromEventMutation = { __typename?: 'Mutation', unlinkUserFromEvent: Array<{ __typename?: 'EventLinkedUser', id: string }> };


export const UnlinkUserFromEventDocument = gql`
    mutation UnlinkUserFromEvent($event_id: ID!, $user_id: ID!) {
  unlinkUserFromEvent(event_id: $event_id, user_id: $user_id) {
    id
  }
}
    `;
export type UnlinkUserFromEventMutationFn = Apollo.MutationFunction<UnlinkUserFromEventMutation, UnlinkUserFromEventMutationVariables>;

/**
 * __useUnlinkUserFromEventMutation__
 *
 * To run a mutation, you first call `useUnlinkUserFromEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkUserFromEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkUserFromEventMutation, { data, loading, error }] = useUnlinkUserFromEventMutation({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useUnlinkUserFromEventMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkUserFromEventMutation, UnlinkUserFromEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkUserFromEventMutation, UnlinkUserFromEventMutationVariables>(UnlinkUserFromEventDocument, options);
      }
export type UnlinkUserFromEventMutationHookResult = ReturnType<typeof useUnlinkUserFromEventMutation>;
export type UnlinkUserFromEventMutationResult = Apollo.MutationResult<UnlinkUserFromEventMutation>;
export type UnlinkUserFromEventMutationOptions = Apollo.BaseMutationOptions<UnlinkUserFromEventMutation, UnlinkUserFromEventMutationVariables>;